import React from "react";
import { Box, Typography, FormControl, Select, MenuItem } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

/**
 * Sección de selección/visualización de empleado (Creado por / Tramitado por)
 */
const SeccionEmpleado = ({
  label,
  empleadoId,
  empleadoNombre,
  empleados,
  esAdmin,
  loading,
  onChange,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          mb: 1,
          color: "#495057",
          fontSize: 13,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <PersonIcon sx={{ fontSize: 18 }} />
        {label}
      </Typography>
      {esAdmin ? (
        <FormControl fullWidth>
          <Select value={empleadoId} onChange={onChange} disabled={loading}>
            {empleados.map((emp) => (
              <MenuItem key={emp.id} value={emp.id.toString()}>
                {emp.nombre}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <Typography sx={{ fontSize: 14, color: "#212529" }}>
          {empleadoNombre || "Sin asignar"}
        </Typography>
      )}
    </Box>
  );
};

export default SeccionEmpleado;
